const ASSET_HOST = 'cdn.bgl.dev'

/** Largest width a CDN asset is delivered at. Article column is 720px. */
const DISPLAY_WIDTH: Record<string, number> = {
	thumb: 256,
	card: 640,
	content: 1440,
	hero: 1920,
}

export type ImageSize = keyof typeof DISPLAY_WIDTH

/**
 * Request a resized WebP for a public asset URL. Non-asset URLs (local
 * fallbacks, SVG, other hosts) are returned unchanged. An existing transform
 * query is left alone so social/og crops are not resized a second time.
 */
export function displayImage(src: string | undefined | null, size: ImageSize = 'content'): string {
	if (!src) return ''
	let url: URL
	try {
		url = new URL(src)
	} catch {
		return src
	}
	if (url.hostname !== ASSET_HOST || url.search) return src
	url.searchParams.set('fmt', 'webp')
	url.searchParams.set('w', String(DISPLAY_WIDTH[size]))
	url.searchParams.set('fit', 'inside')
	url.searchParams.set('q', '75')
	return url.toString()
}
